/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
 
import { IconFileTypeDocx, IconFileTypePdf, IconFileTypePpt, IconFileTypeXls, IconPhoto, IconVideo, Icon } from '@tabler/icons-react';
import { InputType } from 'reactstrap/es/Input';

export enum NSBUTTON_SIZES {
    SMALL = 'sm',
    LARGE = 'lg',
}

export enum FileExtensions {
    PDF = 'pdf',
    DOC = 'doc',
    DOCX = 'docx',
    PPT = 'ppt',
    PPTX = 'pptx',
    XLS = 'xls',
    XLSX = 'xlsx',
    TIFF = 'tiff',
    JPG = 'jpg',
    JPEG = 'jpeg',
    BMP = 'bmp',
    GIF = 'gif',
    PNG = 'png',
    MP4 = 'mp4',
    MOV = 'mov',
}

export const iconsByFilenameExtension: { [key: string]: Icon } = {
    pdf: IconFileTypePdf,
    doc: IconFileTypeDocx,
    docx: IconFileTypeDocx,
    pptx: IconFileTypePpt,
    ppt: IconFileTypePpt,
    xls: IconFileTypeXls,
    xlsx: IconFileTypeXls,
    tiff: IconPhoto,
    jpg: IconPhoto,
    jpeg: IconPhoto,
    bmp: IconPhoto,
    gif: IconPhoto,
    png: IconPhoto,
    mp4: IconVideo,
    mov: IconVideo,
};

export const InputTypes = {
    text: 'text' as InputType,
    email: 'email' as InputType,
    select: 'select' as InputType,
    file: 'file' as InputType,
    radio: 'radio' as InputType,
    checkbox: 'checkbox' as InputType,
    switch: 'switch' as InputType,
    textarea: 'textarea' as InputType,
    button: 'button' as InputType,
    reset: 'reset' as InputType,
    submit: 'submit' as InputType,
    date: 'date' as InputType,
    datetimeLocal: 'datetime-local' as InputType,
    hidden: 'hidden' as InputType,
    image: 'image' as InputType,
    month: 'month' as InputType,
    number: 'number' as InputType,
    range: 'range' as InputType,
    search: 'search' as InputType,
    tel: 'tel' as InputType,
    url: 'url' as InputType,
    week: 'week' as InputType,
    password: 'password' as InputType,
    datetime: 'datetime' as InputType,
    time: 'time' as InputType,
    color: 'color' as InputType,
};

export enum SUBPROJECT_STAGES {
    OPPORTUNITY = 1,
    DUE_DILIGENCE = 2,
    PREDEVELOPMENT = 3,
    CONSTRUCTION = 4,
    STABILIZATION = 5,
    COMPLETED = 6,
    ARCHIVED = 7,
}

export enum NORTHSPYRE_TIER_TYPES {
    NORTHSPYRE_FOR_VENDORS = 'Northspyre for Vendors',
    NORTHSPYRE_PLAN = 'Northspyre Plan',
    NORTHSPYRE_PLAN_PLUS = 'Northspyre Plan+',
    NORTHSPYRE_PRO = 'Northspyre Pro',
    NORTHSPYRE_ENTERPRISE = 'Northspyre Enterprise',
    NORTHSPYRE_HISTORICAL_DATA = 'Northspyre Historical Data',
    NORTHSPYRE_LITE = 'Northspyre Lite',
}

export const subprojectLifeStages = {
    DEAD: 0,
    ACTIVE: 1,
    ARCHIVED: 2,
    EXPORTED: 3,
};

export const MAX_FILE_UPLOAD_2GB = 2 * 1024 * 1024 * 1024;

export enum CONTENT_TYPE {
    PDF = 'application/pdf',
    DOC = 'application/msword',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PPT = 'application/vnd.ms-powerpoint',
    PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    XLS = 'application/vnd.ms-excel',
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    TIFF = 'image/tiff',
    JPG = 'image/jpeg',
    JPEG = 'image/jpeg',
    BMP = 'image/bmp',
    GIF = 'image/gif',
    PNG = 'image/png',
    MP4 = 'video/mp4',
    MOV = 'video/vnd.sealedmedia.softseal.mov',
    MOVQT = 'video/quicktime',
    CSV = 'text/csv',
    SVG = 'image/svg+xml',
}

export enum EXCEL_TYPE {
    XLS = 'application/vnd.ms-excel',
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    XLTX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    XLT = 'application/vnd.ms-excel',
    XLSM = 'application/vnd.ms-excel.sheet.macroenabled.12',
    XLSB = 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    XLTM = 'application/vnd.ms-excel.template.macroenabled.12',
    XLAM = 'application/vnd.ms-excel.addin.macroenabled.12',
    XLA = 'application/vnd.ms-excel',
    SLK = 'application/vnd.ms-excel',
}
